import { Group, Stack } from "@mantine/core"
import { useDebouncedValue } from "@mantine/hooks"
import { PaginationState } from "@tanstack/react-table"
import { Select, DataFetchWrapper } from "@tfg/ui"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

import { filtersSchema } from "@tfg/types/schemas/products"
import { removeUndefined } from "@tfg/types/schemas/utils"

import { ProductFilters } from "~/components/ProductFilters.tsx"
import { useSearchParamsFilters } from "~/components/hooks/useSearchParamsFilters"
import { useProductsQuery } from "~/pages/Brand/Products/List/hooks.ts"
import { ProductsAGECTable } from "~/pages/Brand/Regulations/AGEC/ProductsAGECTable.tsx"

const PAGE_SIZE = 20

export const ProductsAGECWrapper = () => {
  const [filtersValue, setFiltersValue] = useSearchParamsFilters(filtersSchema)

  const [debouncedProduct] = useDebouncedValue<string | undefined>(
    filtersValue.search,
    600
  )
  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: PAGE_SIZE,
  })

  useEffect(() => {
    setPagination((prev) => ({
      ...prev,
      pageIndex: 0,
    }))
  }, [debouncedProduct])

  const productsQuery = useProductsQuery({
    fetchDataOptions: pagination,
    filters: { ...filtersValue, search: debouncedProduct },
  })
  const { t } = useTranslation("regulations")
  return (
    <Stack>
      <DataFetchWrapper query={productsQuery}>
        {({ data, isFetching }) => (
          <Stack>
            <Group>
              <ProductFilters
                setFiltersValue={setFiltersValue}
                filtersValue={filtersValue}
                isFetching={isFetching}
                extraFilters={
                  <Select
                    data={[
                      { value: "yes", label: t("lists.placeholders.yes") },
                      { value: "no", label: t("lists.placeholders.no") },
                    ]}
                    w={150}
                    size="xs"
                    clearable
                    searchable
                    onChange={(value) =>
                      setFiltersValue(
                        removeUndefined({
                          ...filtersValue,
                          agecCompliance: value ?? undefined,
                        })
                      )
                    }
                    placeholder={t("lists.placeholders.agec")}
                    value={filtersValue.agecCompliance ?? null}
                  />
                }
              />
            </Group>
            <ProductsAGECTable
              data={data}
              fetchDataOptions={pagination}
              setPagination={setPagination}
            />
          </Stack>
        )}
      </DataFetchWrapper>
    </Stack>
  )
}
